import { View } from 'react-native';
import React, { useState, useEffect } from 'react';

import Constants from '../constants';
import { UserContext, WpUserAction } from '../contexts/user';
import { LOGIN_USER } from '../graphql/user';
import { useNavigate } from '../react-router';
import { LoginView } from '@ologyhealth/wp-components';
import { useQuery, useMutation } from '@apollo/client';
import { GET_USER } from '../graphql/queries';
import Spinner from '../components/Spinner';

interface LoginParams {
  email: string;
  password: string;
}

export default function Login(): JSX.Element {
  const { state, dispatch } = React.useContext(UserContext);
  const { data, loading } = useQuery(GET_USER, {
    fetchPolicy: 'no-cache',
  });

  const [loggingIn, setLoggingIn] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();

  const navigate = useNavigate();

  const [loginUser, loginUserData] = useMutation(LOGIN_USER, {
    fetchPolicy: 'no-cache',
  });

  const loginBrand = Constants.oppText
    ? 'Ology'
    : Constants.blastView
      ? 'BlastView'
      : Constants.tattooCare
        ? 'TattooCare'
        : 'WhistlePitch';

  useEffect(() => {
    if (state.user) {
      navigate('/dashboard');
    }
  }, [state.user, navigate]);

  useEffect(() => {
    if (data?.user?.success) {
      dispatch({ type: WpUserAction.REFRESH_USER, user: data.user.user });
      navigate('/dashboard');
    }
  }, [data, dispatch, navigate]);

  useEffect(() => {
    if (loginUserData.data) {
      if (!loginUserData.data.loginUser.success) {
        setLoggingIn(false);
        if (loginUserData.data.loginUser.errors.length) {
          setErrorMessage(loginUserData.data.loginUser.errors[0]);
        } else {
          setErrorMessage('An unknown error occurred.');
        }
      } else if (loginUserData.data.loginUser.token) {
        localStorage.setItem('old-user-token', loginUserData.data.loginUser.token);
        window.location.replace(
          'https://www.whistlepitch.com/api/v1/login/' + loginUserData.data.loginUser.token
        );
      } else {
        localStorage.setItem('token', loginUserData.data.loginUser.user.token);
        loginUserData.client.resetStore();
        navigate('/dashboard');
      }
    }
  }, [loginUserData.data, loginUserData.client, navigate]);

  useEffect(() => {
    const token = localStorage.getItem('old-user-token');
    if (token && !Constants.oppText) {
      window.location.replace('https://www.whistlepitch.com/api/v1/login/' + token);
    }
  }, []);

  if (loading || state.user) {
    return <Spinner style={{ marginTop: 40 }} />;
  }

  const onLogin = (params: LoginParams) => {
    setLoggingIn(true);
    setErrorMessage(undefined);
    loginUser({ variables: { email: params.email, password: params.password } });
  };

  const onForgotPassword = () => {
    navigate('/forgot-password-request');
  };

  return (
    <View style={{ flex: 1, minHeight: '100vh' as unknown as number }}>
      {loggingIn ? (
        <Spinner style={{ marginTop: 40 }} />
      ) : (
        <LoginView
          brand={loginBrand}
          onLogin={onLogin}
          errorMessage={errorMessage}
          onForgotPassword={onForgotPassword}
        />
      )}
    </View>
  );
}
